import React from 'react';
import Chip from '@material-ui/core/Chip';
// import DriveFileRenameOutlineIcon from '@material-ui/icons/DriveFileRenameOutline';
// import SendIcon from '@material-ui/icons/Send'; // ícone de documento

export const getDisponibilidadeColumns = () => [
  { Header: '#', accessor: 'id', disableGlobalFilter: true, width: 65 },
  { Header: 'Data', accessor: 'data' },
  { Header: 'Vazio em', accessor: 'vazioem' },
  { Header: 'Estado - UF', accessor: 'estado' },
  { Header: 'Frota', accessor: 'frota' },
  { Header: 'Tipo veículo', accessor: 'tipoveiculo' },
  { Header: 'Gestor', accessor: 'gestor' },
  {
    Header: 'Vazio',
    accessor: 'vazio',
    Cell: ({ value }) => (
      <Chip
        label={value}
        style={{
          backgroundColor: value === 'Sim' ? '#4caf4f50' : '#f44336a0',
          color: '#414141',
          borderRadius: '15px'
        }}
      />
    )
  },
  {
    Header: 'Coleta',
    accessor: 'coleta',
    Cell: ({ value }) => (
      <Chip
        label={value}
        style={{
          backgroundColor: value === 'Sim' ? '#4caf4f50' : '#f44336a0',
          color: '#414141',
          borderRadius: '15px'
        }}
      />
    )
  },
  {
    Header: 'Negociação', 
    accessor: 'negociacao',
    Cell: ({ value }) => (
      <Chip
        label={value}
        style={{
          backgroundColor: value === 'Sim' ? '#4caf4f50' : '#f44336a0',
          color: '#414141',
          borderRadius: '15px'
        }}
      />
    )
  },
  { Header: 'Comercial', accessor: 'comercial' },
  { Header: 'Destino', accessor: 'destino' },
  { Header: 'Dias parados', accessor: 'disparados' }
];